import ArchiveTable from '../components/ArchiveTable';

const TrialArchivePage = () => {
	return (
		<main>
			<ArchiveTable />
		</main>
	);
};
export default TrialArchivePage;
